import { ListItemContentPlugin } from '@udecode/plate-list/react'
import { Transformer } from 'unified'
import { visit } from 'unist-util-visit'

import { defaultNodeTypes, MdastNode } from './ast-types'

/**
 * Plate JS prefers content inside `<li>` element to be wrapped in `<lic>`. However, `remark-markdown` wraps everything
 * inside `<li>` in a `<paragraph>`.
 *
 * Therefore, we need to convert `paragraph` inside `li` to `lic`.
 */
const remarkPreserveListContent = () => {
    const transformer: Transformer = (tree, _file) => {
        visit(tree, 'paragraph', (node: MdastNode, _index, parent: MdastNode) => {
            if (parent.type === defaultNodeTypes.listItem) {
                node.type = ListItemContentPlugin.key
            }
        })

        /**
         * We don't want code-block inside list. Convert `code` inside `li` to `lic` and append the
         * text inside as children of a text node.
         */
        visit(tree, 'code', (node: MdastNode, _index, parent: MdastNode) => {
            if (parent.type === defaultNodeTypes.listItem) {
                node.type = ListItemContentPlugin.key
                node.children = [
                    {
                        type: 'text',
                        value: '``` ' + [node.lang, node.meta, node.value].join(' '),
                    },
                ]
            }
        })
    }

    return transformer
}

export default remarkPreserveListContent
